<div class="container">
  <div class="row">
    <div class="col-lg-12">
      <div class="loader_div_GMJ" *ngIf="loader">
        <span class="loader_GMJ"></span>
      </div>
      <form [formGroup]="form" (ngSubmit)="onFormSubmit()">
        <input type="hidden" formControlName="currency">
        <input type="hidden" class="form-control" placeholder="type" formControlName="type">
        <div class="  fd p_15 rds_5 bg_7">
          <div class="row">
            <!-- <div class="col-sm-3 mt-3" *ngFor="let type of types;let i = index">
                <input type="checkbox" name="{{type}}" [(ngModel)]="type.isChecked" [ngModelOptions]="{standalone: true}" (change)="onChangetype(type.senttype,type.isChecked)"
                  class="m_r_10" checked>{{type.senttype}}<br>
              </div> -->
            <button
              [ngClass]="{'activeBtn': selectedType[0] == 'Deposits','defaultBtn': selectedType[0] !== 'Deposits'}"
              type="button" (click)="onChangetype('Deposits', true)">{{'DEPOSIT' | translate}}</button>
            <button
              [ngClass]="{'activeBtn':selectedType[0] == 'Cashouts', 'defaultBtn': selectedType[0] !== 'Cashouts'}"
              type="button" (click)="onChangetype('Cashouts', true)">{{'CASHOUT' | translate}}</button>
          </div>

          <div class="fd m_t_10">
            <div class="row payKsamaInp align-items-end">
              <!-- From Date -->
              <!-- <div class="col-sm-5">
                <mat-form-field appearance="fill" class="custom-date-field w-100">
                  <mat-label>From Date*</mat-label>
                  <input matInput [matDatepicker]="picker1" formControlName="startDate" [max]="endDate"
                    [ngModel]="startDate | date:'yyyy-MM-dd'" (ngModelChange)="startDate = $event" />
                  <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
                <small class="error fielderror" *ngIf="!form.get('startDate')?.valid && form.get('startDate')?.touched">
                  Select start date
                </small>
              </div> -->

              <!-- To Date -->
              <!-- <div class="col-sm-5">
                <mat-form-field appearance="fill" class="custom-date-field w-100">
                  <mat-label>To Date*</mat-label>
                  <input matInput [matDatepicker]="picker2" formControlName="endDate" [max]="todaydate"
                    [ngModel]="endDate | date:'yyyy-MM-dd'" (ngModelChange)="endDate = $event" />
                  <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
                <small class="error fielderror" *ngIf="!form.get('endDate')?.valid && form.get('endDate')?.touched">
                  Select end date
                </small>
              </div> -->


              <div class="col-sm-12">
                <!-- From Date -->
                <div class="df_flex-col date-picker-cls">
                  <label>{{'FROM_DATE' | translate}}*</label>
                  <input type="date" formControlName="startDate" [max]="endDate || todaydate"
                    [ngModel]="startDate ? (startDate | date:'yyyy-MM-dd') : ''" (ngModelChange)="startDate = $event"
                    required>
                </div>
                <small class="error fielderror" *ngIf="form.get('startDate')?.errors && form.get('startDate')?.touched">
                  <span *ngIf="form.get('startDate')?.errors?.['required']">
                    {{ 'SELECT_START_DATE' | translate }}
                  </span>

                  <span *ngIf="form.get('startDate')?.errors?.['max']">
                    {{ 'START_DATE_AFTER_END' | translate }}
                  </span>
                </small>
              </div>

              <!-- To Date -->
              <div class="col-sm-12">
                <div class="df_flex-col date-picker-cls">
                  <label>{{'TO_DATE' | translate}}*</label>
                  <input type="date" formControlName="endDate" [min]="startDate" [max]="todaydate"
                    [ngModel]="endDate ? (endDate | date:'yyyy-MM-dd') : ''" (ngModelChange)="endDate = $event"
                    required>
                </div>
                <small class="error fielderror" *ngIf="form.get('endDate')?.errors && form.get('endDate')?.touched">
                  <span *ngIf="form.get('endDate')?.errors?.['required']">
                    {{ 'SELECT_END_DATE' | translate }}
                  </span>

                  <span *ngIf="form.get('endDate')?.errors?.['min']">
                    {{ 'END_DATE_BEFORE_START' | translate }}
                  </span>

                  <span *ngIf="form.get('endDate')?.errors?.['max']">
                    {{ 'END_DATE_FUTURE' | translate }}
                  </span>
                </small>
              </div>

              <!-- Show Button -->
              <div class="col-sm-12">
                <!-- <button type="submit" class="show-button float-right" -->
                <button type="submit" class="trans_btns m_t_25" [ngClass]="{ 'backp_color': form.invalid || steddate }"
                  [disabled]="form.invalid || steddate">
                  {{'SHOW' | translate}}
                </button>
              </div>

              <!-- Hidden Inputs -->
              <div class="input-group">
                <input type="text" class="form-control" placeholder="limit" formControlName="limit" hidden />
                <input type="text" class="form-control" placeholder="index" formControlName="index" hidden />
              </div>
            </div>
          </div>


        </div>
        <div class="error fielderror fd m_l_10 m_t_10" *ngIf="steddate">{{ 'DATE_RANGE_INVALID' | translate }}</div>

      </form>
      <div class="cart-table-area">
        <div class="fd" *ngIf="errormessage">
          <p class="errorTRA">
            {{errormessage | translate}}
          </p>
        </div>
        <!-- <div class="fd trnas_am" *ngIf="showDepositTable">
          Deposits
        </div> -->
        <div class="fd d_grid" *ngIf="showDepositTable">
          <div class="history-table-container">
            <table class="fd">
              <thead>
                <tr>
                  <th>Date</th>
                  <th class="text-center">Amount</th>
                  <th class="text-center">Bonus</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of depositTransactiondata | paginate: {itemsPerPage:selectnum, currentPage: p, id: 'p'};">
                  <td>{{data.startDate | slice:0:19}}</td>
                  <td class="text-center">{{toFixed(data.cashAmount) }}
                  </td>
                  <td class="text-center">{{data.bonus | slice:0:1 }}

                  </td>
                  <td style="padding: 8px 10px ;">
                    <div class="newstyle" *ngIf="data.status == 'Started'">
                      <!-- <span class="img-border">
                      <div class="spin">◌</div>
                      </span> -->
                      {{ data.status }}
                    </div>
                    <div class="newstyle1" *ngIf="data.status !== 'Started'">🔒 {{ data.status }}
                    </div>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>


          <div class="table-footer fd">
            <select class="selt_bkp slct_wid" (change)="onChangehisti($event)">
              <option *ngFor="let count of itemsperpagecount" [selected]="selectnum == count.num">
                {{ count.num }}
              </option>
            </select>

            <pagination-controls class="pagination justify-content-end pt-2 page-item" (pageChange)="p=$event" id="p">
            </pagination-controls>

          </div>


        </div>

        <div class="fd d_grid" *ngIf="showCashoutTable">

          <div class="history-table-container">
            <table class="fd">
              <thead>
                <tr>
                  <th>Date</th>
                  <th class="text-center">Amount</th>
                  <th class="text-center">Cancelled Amount</th>
                  <th class="text-center">Paid Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let data of cashoutTransactiondata | paginate: {itemsPerPage:cashselectnum, currentPage: p, id: 'p'};">
                  <td>{{data.createdOn | slice:0:19}}</td>
                  <td class="text-center">{{toFixed(data.amount) }}

                  </td>
                  <td class="text-center">{{toFixed(data.cancelledAmount) }}

                  </td>
                  <td class="text-center">{{toFixed(data.paidAmount) }}

                  </td>
                  <td [style.color]="data.status === 'Failed' ? 'red' : ''">
                    {{ data.status == 'Closed'?'Approved': data.status }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-footer">
            <select class="selt_bkp slct_wid" (change)="cashChange($event)">
              <option *ngFor="let count of itemsperpagecountcash" [selected]="cashselectnum == count.num">
                {{ count.num }}
              </option>
            </select>

            <pagination-controls class="pagination justify-content-end pt-2 page-item" (pageChange)="q=$event" id="q">
            </pagination-controls>

          </div>

        </div>
      </div>

    </div>
  </div>
</div>
<!-- Cart Area End -->